// Base
import Image from 'next/image'
import Link from 'next/link'
import dynamic from 'next/dynamic'

// Components
import { Container, Box, Flex, Text, Button } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
const RecentDealCard = dynamic(
  () => import('@components/v25/es/ft1/cards/recent-deal/RecentDealCard'),
  {
    ssr: false
  }
)
// Assets
import GuaranteeBadge from '@images/v25/badges/best-price-guarantee.svg'

// Data
import deals from '@data/v25/es/ft1/deals.json'

interface RecentDealsProps {
  redirectURL?: string
}

const RecentDeals = ({
  redirectURL = '/v25/es/membership'
}: RecentDealsProps) => {
  return (
    <Section padding={[64, 0]}>
      <Box>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
          spacing={{ sm: 32 }}
        >
          TOP 3 Ofertas Recientes
        </Text>

        <Container>
          <Flex flexDirection="column" rowGap={{ sm: 16 }} spacing={{ sm: 48 }}>
            {deals.slice(0, 3).map((deal, index) => (
              <RecentDealCard {...deal} key={index} />
            ))}
          </Flex>
        </Container>
      </Box>

      <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 32 }}>
        La mayoría de las ofertas tienen entre un <strong>60 a 90%</strong> de
        descuento sobre el precio normal. Solo te enviaremos las ofertas de
        vuelos con mayores descuentos desde tu ubicación.
      </Text>

      <Flex flexDirection="column" center rowGap={{ sm: 32 }}>
        <Button as={Link} href={redirectURL} variant="yellow-sm">
          registrarse
        </Button>

        <Image
          src={GuaranteeBadge}
          alt="Best price guarantee badge"
          width={181}
          height={48}
          priority
        />
      </Flex>
    </Section>
  )
}

export default RecentDeals
